/**
 * @description This function converts SelectorCategoryData[] SuggestData
 */
export const convertObjectDataToSuggestData = (selectorCategoriesData) => {
    const suggestData = {
        suggestItems: null,
        suggestLists: []
    };
    if (selectorCategoriesData.length) {
        selectorCategoriesData.forEach(selectorCategory => {
            const suggestList = {
                label: selectorCategory.name,
                items: []
            };
            selectorCategory.items.forEach((objectData) => {
                const suggestItem = {
                    value: objectData.id,
                    description: objectData.description,
                    icon: objectData.icon
                };
                suggestList.items.push(suggestItem);
            });
            suggestData.suggestLists.push(suggestList);
        });
    }
    return suggestData;
};
//# sourceMappingURL=helpers.js.map
